import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useProducts = (
  userToken,
  slug,
  setIsLoading,
  setShowAlert,
  setAlertText
) => {
  const baseUrl = useBaseUrl();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/digikala/${slug}/product-varients`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setProducts(response.data.products);
        setIsLoading(false);
        if (response.data.products.length === 0) {
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
          setAlertText("موردی یافت نشد");
        }
      } catch (error) {
        console.log("Error during getting products", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (userToken) {
      fetchProducts();
    }
  }, [baseUrl, userToken]);

  return { products };
};

export default useProducts;
